import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	MimaTextArea,
	ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import unitOfMeasurement from '../../utils/unitOfMeasurement.json';
import { inventoryStore } from '../../stores';
import { Formik } from 'formik';

const EditModal = ({
	closeModal,
	goBack,
	loading,
	selectOneClick,
	selectTwoClick,
	selectThreeClick,
	fileOne,
	fileTwo,
	fileThree,
	validationSchema,
	verifyAccountNumber,
	banks,
	setAccountName,
	accountName,
	onSubmit,
	setLoading,
}) => {
	const { selectedProduct } = inventoryStore;

	return (
		<>
			<MimaText variant="subtitleBold" align="center" mb={3}>
				Edit {selectedProduct?.type === 'Product' ? 'Product' : 'Service'}
			</MimaText>

			<Formik
				initialValues={{
					name: selectedProduct.name,
					description: selectedProduct.description,
					type: selectedProduct.type,
					unitOfMeasurement: selectedProduct.unitOfMeasurement,
					hasImages: false,
					hasSplit: selectedProduct.hasSplit || false,
					splitName: selectedProduct?.split?.name || '',
					splitType: selectedProduct?.split?.type || '',
					splitPhone: selectedProduct?.split?.phone || '',
					splitEmail: selectedProduct?.split?.email || '',
					accountName: selectedProduct?.split?.accountName || '',
					accountNumber: selectedProduct?.split?.accountNumber || '',
					bank: selectedProduct?.split?.bank || '',
					bankCode: selectedProduct?.split?.bankCode || '',
					grade: selectedProduct?.split?.grade || '',
					autoCreateStock: selectedProduct?.split?.autoCreateStock || false,
					// splitPaymentTrigger: selectedProduct?.splitPaymentTrigger || '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					values,
					errors,
					touched,
					setFieldValue,
				}) => (
					<div>
						<div className={styles.type}>
							<MimaText variant="small" mb={2} mt={2} >
								Type
							</MimaText>
							<div className="modal__beside">
								<RCB
									title="Product"
									onChange={() => {
										setFieldValue('type', 'Product');
									}}
									checked={values.type === 'Product'}
									value="Product"
									name="type"
								/>
								<RCB
									title="Service"
									checked={values.type === 'Service'}
									onChange={() => setFieldValue('type', 'Service')}
									value="Service"
									name="type"
								/>
							</div>
							{errors.type ? (
								<div className={styles.error}>
									{''}
									{touched.type && errors.type}
									{''}
								</div>
							) : null}
						</div>

						<MimaInput
							type="text"
							labelTitle={`${values.type} Name(max 50 characters)`}
							name="name"
							id="name"
							value={values.name}
							onChange={handleChange}
							error={errors.name}
							touched={touched.name}
							onBlur={handleBlur}
						/>

						<MimaTextArea
							type="text"
							labelTitle={`${values.type} Description(max 100 characters - optional)`}
							name="description"
							id="description"
							value={values.description}
							onChange={handleChange}
							onBlur={handleBlur}
							touched={touched.description}
							error={errors.description}
						/>

						<MimaDropdown
							labelTitle="Select Unit Of Measurement"
							placeholder={values.unitOfMeasurement}
							currentValue={values.unitOfMeasurement}
							name="unitOfMeasurement"
							value={values.unitOfMeasurement}
							id="unitOfMeasurement"
							onChange={data => {
								setFieldValue('unitOfMeasurement', data.key);
							}}
							data={
								values.type === 'Product'
									? unitOfMeasurement.product.map(item => ({
										key: item,
										value: item,
									}))
									: unitOfMeasurement.service.map(item => ({
										key: item,
										value: item,
									}))
							}
							touched={touched.unitOfMeasurement}
							error={errors.unitOfMeasurement}
						/>

						<div className={styles.invoice__checks_group}>
							<div className="modal__beside">
								<RCB
									title="Update Image(s) - (Optional)"
									onChange={() => {
										setFieldValue('hasImages', !values.hasImages);
									}}
									checked={values.hasImages}
									value={values.hasImages}
									name="hasImages"
								/>

							</div>
							{errors.hasImages ? (
								<div className={styles.error}>
									{''}
									{touched.hasImages && errors.hasImages}
									{''}
								</div>
							) : null}
						</div>

						{values.hasImages && (
							<>
								<MimaButton
									title={
										fileOne === null ? 'Select Front Image' : 'Front Image Selected'
									}
									variant="outlined"
									width={38}
									onClick={selectOneClick}
									mt={2}
								/>
								{fileOne !== null ? (
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginTop: '2rem',
										}}>
										<img
											className={styles.imageUpload}
											src={fileOne?.source || ''}
											alt="preview"
										/>
									</div>
								) : (
									''
								)}

								<MimaButton
									title={
										fileTwo === null ? 'Select Back Image' : 'Back Image Selected'
									}
									variant="outlined"
									width={38}
									onClick={selectTwoClick}
									mt={2}
								/>
								{fileTwo !== null ? (
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginTop: '2rem',
										}}>
										<img
											className={styles.imageUpload}
											src={fileTwo?.source || ''}
											alt="preview"
										/>
									</div>
								) : (
									''
								)}

								<MimaButton
									title={
										fileThree === null ? 'Select Side Image' : 'Side Image Selected'
									}
									variant="outlined"
									width={38}
									onClick={selectThreeClick}
									mt={2}
									mb={2}
								/>
								{fileThree !== null ? (
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginBottom: '2rem',
										}}>
										<img
											className={styles.imageUpload}
											src={fileThree?.source || ''}
											alt="preview"
										/>
									</div>
								) : (
									''
								)}
							</>
						)}
						<div className={styles.type}>
							<div className="modal__beside">
								<RCB
									title="Split Payment with vendor?"
									onChange={() => {
										setFieldValue('hasSplit', !values.hasSplit);
									}}
									checked={values.hasSplit}
									value={values.hasSplit}
									name="hasSplit"
								/>
							</div>
							{errors.hasSplit ? (
								<div className={styles.error}>
									{''}
									{touched.hasSplit && errors.hasSplit}
									{''}
								</div>
							) : null}
						</div>
						{values.hasSplit && (
							<>
								<div className={styles.bus__details}>
									<MimaDropdown
										labelTitle="Split Type"
										placeholder={values.splitType}
										currentValue={values.splitType}
										data={['PROFIT', 'SELLING PRICE'].map(type => {
											return {
												key: type,
												value: type,
											};
										})}
										id="splitType"
										onChange={data => {
											setFieldValue('splitType', data.key);
										}}
										name="splitType"
										onBlur={handleBlur}
										touched={touched.splitType}
									/>
									<div className={styles.type}>
										<div className="modal__beside">
											<RCB
												title="Create Stock using existing Rate card?"
												onChange={() => {
													setFieldValue('autoCreateStock', !values.autoCreateStock);
												}}
												checked={values.autoCreateStock}
												value={values.autoCreateStock}
												name="autoCreateStock"
											/>
										</div>
									</div>

									{values.autoCreateStock && (
										<MimaDropdown
											labelTitle="Select Grade"
											placeholder={'-Select-'}
											name="grade"
											value={values.grade}
											currentValue={values.grade}
											id="grade"
											onChange={data => {
												setFieldValue('grade', data.key);
											}}
											data={[
												{
													value: 'STANDARD',
													key: 'STANDARD',
												},
												{
													value: 'BUDDING',
													key: 'BUDDING',
												},
												{
													value: 'PREMIUM',
													key: 'PREMIUM',
												},
												{
													value: 'TOP',
													key: 'TOP',
												},
												{
													value: 'EXCEPTIONAL',
													key: 'EXCEPTIONAL',
												},

											]}
											touched={touched.grade}
											error={errors.grade}
										/>
									)}
									<MimaInput
										type="text"
										labelTitle="Name of Business or Individual"
										name="splitName"
										id="splitName"
										value={values.splitName}
										onChange={handleChange}
										touched={touched.splitName}
										onBlur={handleBlur}
									/>
									<MimaInput
										type="text"
										labelTitle="Business or Individual Email"
										name="splitEmail"
										id="splitEmail"
										value={values.splitEmail}
										onChange={handleChange}
										touched={touched.splitEmail}
										onBlur={handleBlur}
									/>
									<MimaInput
										type="text"
										labelTitle="Business or Individual Phone"
										name="splitPhone"
										id="splitPhone"
										value={values.splitPhone}
										onChange={handleChange}
										touched={touched.splitPhone}
										onBlur={handleBlur}
									/>

									<MimaDropdown
										labelTitle="Bank Name"
										placeholder={values.bank}
										currentValue={values.bankCode}
										data={banks}
										id="bankCode"
										onChange={data => {
											setFieldValue('bankCode', data.id);
											setFieldValue('bank', data.value);
										}}
										name="bankCode"
										onBlur={handleBlur}
										error={errors.bankCode}
										touched={touched.bankCode}
									/>
									<MimaInput
										type="text"
										labelTitle="Account Number"
										name="accountNumber"
										value={values.accountNumber}
										onChange={e => {
											setLoading(true);
											verifyAccountNumber({
												accountNumber: e.target.value,
												beneficiaryBank: values.bankCode,
											}).then(data => {
												setAccountName(data);
												setLoading(false);
											});
											handleChange(e);
										}}
										onBlur={handleBlur}
										error={errors.accountNumber}
										touched={touched.accountNumber}
									/>
									<MimaInput
										type="text"
										disabled={true}
										labelTitle="Account Name"
										name="accountName"
										value={accountName || values.accountName}
										placeholder={accountName}
										onChange={handleChange}
										onBlur={handleBlur}
									/>

									{/* <MimaDropdown
										labelTitle="When after sales do you want to trigger Split Payment with the Vendor?"
										placeholder={values.splitPaymentTrigger || '-Select-'}
										name="splitPaymentTrigger"
										value={values.splitPaymentTrigger}
										currentValue={values.splitPaymentTrigger}
										id="splitPaymentTrigger"
										onChange={data => {
											setFieldValue('splitPaymentTrigger', data.key);
										}}
										data={['IMMEDIATELY', 'END OF DAY', 'NEXT DAY', 'WEEKLY', 'MONTHLY'].map(value => {
											return {
												key: value,
												value,
											}
										})}
										touched={touched.splitPaymentTrigger}
									/> */}
								</div>
							</>
						)}

						<MimaButton
							title="Continue"
							onClick={handleSubmit}
							variant="form"
							loading={loading}
						/>
					</div>
				)}
			</Formik>
		</>
	);
};

export default EditModal;
